import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { formatVal } from '../../../../helpers/value'
import { selectOwnershipAndGroup } from '../../store/slice'
import { DATA_KEYS } from './helper'
import classes from './index.module.scss'

export const InfoList = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectOwnershipAndGroup())

  return (
    <Element className={classes.infoList}>
      {Object.keys(DATA_KEYS)
        .slice(0, 5)
        .map((key) => (
          <Element
            key={key}
            className={classes.infoItem}
            style={{ color: '#3A414B', backgroundColor: '#F1F3F4' }}
          >
            <Element>
              <Translate value={`companySummary.ownershipGroup.${key}`} />
            </Element>
            <Element style={{ fontSize: 24 }}>
              {formatVal(data[DATA_KEYS[key]], locale, false, 0)}
            </Element>
          </Element>
        ))}
    </Element>
  )
}
